export const environment = {
  api: process.env.REACT_APP_API,
};
